export default __webpack_public_path__ + "static/media/container-hover.2d79d6c7.png";